import React from "react";
import ProductCategory from "../../productcategory2";
import SEO from "../../seo";

export default function ViscoMattressPage() {
  const data = {
    categoryName: "VISCO SERIES",
    description:
      "Eclipse Visco Series is engineered using the finest and the most advanced anti-allergen Eclipse Visco Memory Foam. These mattresses adjust to the sleeper’s body heat for added comfort, and relieve pain, body aches and soreness, making it the ideal choice for preventing and alleviating chronic spinal conditions and improving sleep posture.",
    benefits: [
      "Made of the finest and most advanced anti-allergen Eclipse Memory Foam",
      "Relives pains, body aches, and soreness by selectively displacing pressure along the length of the person’s body",
      "Memory Foam is a temperature sensitive material that allows these mattress to adjust itself to the sleeper’s body heat and body weight",
      "Prevents and alleviates chronic spinal conditions while improving sleep posture by assisting with proper spinal alignment when lying down",
    ],
    products: [
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-comfort-PT.png",
        name: "POSTURE COMFORT",
        link: "/luxury-collection/posture-comfort/",
        startingAt: "₹24,199",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Posture-Therapy-PT-1.png",
        name: "POSTURE THERAPY",
        link: "/luxury-collection/posture-therapy/",
        startingAt: "₹22,499",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2021/06/1000X667-2.png",
        name: "POSTURE CARE",
        link: "/luxury-collection/posture-care/",
        startingAt: "₹21,699",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Ortho-visco.png",
        name: "ORTHO VISCO",
        link: "/visco-mattress/ortho-visco/",
        startingAt: "₹17,099",
      },
    ],
    brochureLink: "https://eclipsemattress.in/assets/pdfs/Eclipse-Catalog.pdf",
    actionToAccess: false,
    banner: "https://eclipsemattress.in/assets/images/banners/visco-d.jpg",
    bannerSm: "https://eclipsemattress.in/assets/images/banners/visco-m.jpg",
    // pattern,
  };
  return (
    <div>
      <SEO
        title="Best Memory Foam Mattress | Eclipse International"
        description="Buy Best Memory Foam Mattress from Eclipse International adjust to the sleeperâ€™s body heat for added comfort, and relieve pain, body aches and soreness, making it the ideal choice for preventing and alleviating chronic spinal conditions and improving sleep posture"
        img="https://eclipsemattress.in/assets/linkpreviews/category/visco-mattress.jpg"
      />
      <ProductCategory category={data} />
    </div>
  );
}
